type TeamMember = {
  photo?: string;
  photoPosition?: string;
  initials?: string;
  name: string;
  role: string;
  note?: string;
  points: string[];
};

const coreTeam: TeamMember[] = [
  {
    photo: "/team-ben.jpg",
    photoPosition: "center top",
    name: "BEN ZHANG",
    role: "CEO & Co-founder",
    points: ["Ex-CTO Bite Investments", "15+ years software · $100M+ value created", "Founded & exited a fintech agency"],
  },
  {
    photo: "/team-hugh.jpg",
    photoPosition: "center 15%",
    name: "HUGH CARNEGIE",
    role: "COO & Co-founder",
    points: ["Ex Head of Ops, Bite Stream", "3x product GTM to $5M ARR", "Operational playbook specialist"],
  },
  {
    photo: "/team-yiyan.jpg",
    name: "YIYAN NG",
    role: "CTO",
    note: "Joining at seed",
    points: ["Meta · ML Engineer", "NYU Courant MSCS · LBS MAM", "ML, computer vision, deep learning"],
  },
  {
    photo: "/team-cher.png",
    name: "CHER TRUMAN",
    role: "Marketing & Growth",
    note: "Joining at seed",
    points: ["WPP Media · brand strategy", "AI marketing & client acquisition", "Pinterest, Müller accounts"],
  },
];

const advisors: TeamMember[] = [
  {
    photo: "/team-george.png",
    name: "GEORGE YANG",
    role: "Strategic Advisor",
    points: ["Investor: Anthropic, Stripe, xAI, Databricks", "Ex-Partner CVC · $10B AUM"],
  },
  {
    photo: "/team-loo.png",
    photoPosition: "center 25%",
    name: "CHENG-GUAN LOO",
    role: "Strategic Advisor",
    points: ["30+ years fund management", "PE, M&A, capital structuring · Board-level"],
  },
];

const Avatar = ({ m, size }: { m: TeamMember; size: number }) => (
  <div
    className="rounded-full overflow-hidden shrink-0 bg-[var(--color-surface)] border border-[var(--color-border)] flex items-center justify-center"
    style={{ width: size, height: size }}
  >
    {m.photo ? (
      <img
        src={m.photo}
        alt={m.name}
        className="w-full h-full object-cover"
        style={{ objectPosition: m.photoPosition }}
      />
    ) : (
      <span className="text-[20px] font-light tracking-widest font-[family-name:var(--font-heading)] text-[var(--color-fg-secondary)]">
        {m.initials}
      </span>
    )}
  </div>
);

export function V3TeamSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[28px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
        Built to scale with AI
      </h2>

      {/* Core team — 4 vertical cards */}
      <div className="grid grid-cols-4 gap-3 mb-3">
        {coreTeam.map((m) => (
          <div key={m.name} className="flex flex-col items-center text-center">
            <div className="mb-2">
              <Avatar m={m} size={76} />
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.15em] mb-0.5">
              {m.name}
            </div>
            <div className="text-[9px] text-[var(--color-accent)] uppercase tracking-[0.1em] mb-1.5 leading-snug">
              {m.role}
            </div>
            <ul className="space-y-0.5">
              {m.points.map((p) => (
                <li key={p} className="text-[10px] text-[var(--color-fg-secondary)] leading-snug">{p}</li>
              ))}
            </ul>
            {m.note && (
              <div className="mt-1.5 text-[9px] text-[#4533f7] font-medium font-[family-name:var(--font-mono)] uppercase tracking-wider">
                {m.note}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Advisors — aligned with core grid: avatar 1 under Ben (col 1), avatar 2 under Yiyan (col 3) */}
      <div>
        <div className="text-[9px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-fg-tertiary)] uppercase tracking-[0.15em] mb-4 pb-1.5 border-b border-[var(--color-border)]">
          Advisors
        </div>
        <div className="grid grid-cols-4 gap-3 mt-6">
          {advisors.map((m) => (
            <div
              key={m.name}
              className="col-span-2 flex items-center gap-4"
              style={{ paddingLeft: "calc(25% - 38px)" }}
            >
              <Avatar m={m} size={76} />
              <div className="flex flex-col">
                <div className="text-[10px] font-bold uppercase tracking-[0.15em] mb-0.5">
                  {m.name}
                </div>
                <div className="text-[9px] text-[var(--color-accent)] uppercase tracking-[0.1em] mb-1.5 leading-snug">
                  {m.role}
                </div>
                <ul className="space-y-0.5">
                  {m.points.map((p) => (
                    <li key={p} className="text-[10px] text-[var(--color-fg-secondary)] leading-snug">{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)] font-[family-name:var(--font-mono)] text-[10px] flex gap-6">
        <span className="whitespace-nowrap">
          <span className="text-[var(--color-accent)] font-bold mr-1">DEV</span>
          <span className="text-[var(--color-fg-secondary)]">5-person engineering team. Ship 24/7 with AI-assisted development.</span>
        </span>
        <span className="ml-auto text-right whitespace-nowrap">
          <span className="text-[var(--color-fg)] font-bold mr-1">KEY SEED HIRE:</span>
          <span className="text-[var(--color-fg-secondary)]">Head of Corp Dev. Deal sourcing. Valuation. Integration.</span>
        </span>
      </div>
    </div>
  );
}
